@if (!collapsed) {
  <div class="mt-1">What is the date of the most recent specialist encounter?</div>
  <div class="help-text"><small class="text-muted fst-italic">Found in consult note</small></div>
}
<app-validate-specialist-encounter-verifications
  [collapsed]="collapsed"
  [patientAttachment]="patientAttachment"
  (verificationChange)="onVerificationChange($event)"
  (verificationRemove)="onVerificationRemove($event)" />
<app-validate-specialist-encounter-relevant-written-dates
  [collapsed]="collapsed"
  [patientAttachment]="patientAttachment"
  [writtenDates]="matchingPrescriberDrugsWrittenDates" />
